export enum EntityType {
  CART = "cart",
  USER = "user",
  CHAT = "chat",
  ORDER = "order",
  SAMPLE = "sample",
  SAMPLE_CLIENT = "sample_client",
  VENDOR = "vendor",
  INVOICE = "invoice",
  NON_INVENTORY = "non_inventory",
  RESEARCH_AREA = "research_area",
  LOINC_BIOMARKER = "loinc_biomarker",
  STORAGE_FACILITY = "storage_facility",
  COMPANY = "company",
}
